<template>
    <div class="mt-8">
        <!-- filter -->
		<v-row></v-row>
		<bee-handy-table
			:items="items"
			:headers="headers"
			:items-per-page="-1"
			hide-default-footer 
		>
		</bee-handy-table>
		<section class="my-2">
			<h4 class="my-2"> Projects </h4>
			<div>
				<v-card width="220" height="175">
					<v-card-title class="d-flex justify-center py-0 white--text" style="background-color: #157283; height: 41px; min-height: 29px;">
						Ibn alhaytham
					</v-card-title>
					<v-card-text class="pt-3">
						<div class="d-flex justify-center">
							<v-img width="50" src="../../assets/logo-eng (2).png" />
						</div>
					</v-card-text>

						<v-divider class="mx-1" />
					<v-card-actions class="d-flex justify-center py-0">
						<v-btn :to="{ name: 'one-project', id: 'f7d6ec74-b34e-4772-81d9-08dcac7de40c' }" text class="text-none">
							Show project statistics
						</v-btn>
					</v-card-actions>
				</v-card>
			</div>
		</section>
    </div>
</template>

<script>
export default {
	data () {
		return {
			expanded: [],
			singleExpand: false,
			items: [
				{
					name: 'Octopharma',
					minutes: '14000',
					tasks: '1200',
					// role: ''
					hourCount: '8400',
					date: '01-01-2025'
				}
			]
		}
	},
	computed: {
		headers () {
			return [
				{
					text: 'Contributed users',
					name: 'name',
					value: 'name'
				},
				{
					text: 'Total time spent',
					name: 'total-time',
					value: 'minutes'
					// setValueExpr: val => (val / 60).toFixed(2)
				},
				{
					text: 'Total Task',
					name: 'total-task',
					value: 'tasks'
				},
				{
					text: 'Hour count',
					name: 'hourCount',
					value: 'hourCount'
				},
				{
					text: 'Project entry date',
					name: 'date',
					value: 'date'
				}
			]
		}
	},
	created () {
		this.$store.dispatch('categories/fetchAll')
	}
}
</script>
